import React from 'react'
import WorkplaceQuizModuleMenu from './WorkplaceQuizModuleMenu'
import WorkplaceResultsResourceItems from './WorkplaceResutlsResourceItems'

export interface IWorkplaceResultsResourcesProps {
  isOpen: boolean
  startQuiz: (id: number) => void
  viewResult: () => void
  menuToggled: () => void
}

const WorkplaceResultsResources = (props: IWorkplaceResultsResourcesProps) => {
  return (
    <>
      <div className="contentAll">
        <div className="summary">
          <div className="barHeaderIntro">
            <div
              className="quickMenuArea"
              onClick={() => props.menuToggled()}
              role="button"
              tabIndex={0}
              onKeyUp={(event) => {
                if (event?.keyCode == '13') {
                  props.menuToggled()
                }
              }}
            >
              <a className="quickMenu">
                <img
                  src="/public/workplace/assets/images/button/clear/quickmenu_normal.png"
                  alt="Quick Menu"
                />
                <span>Quick Menu - show/hide above.</span>
              </a>
            </div>
            <WorkplaceQuizModuleMenu
              isOpen={props.isOpen}
              viewResult={props.viewResult}
              startQuiz={props.startQuiz}
            />
            <div className="title">
              <h2 className="titleContent">
                Workplace <span>Basics</span>
              </h2>
            </div>
          </div>
          <div className="content resource">
            <div className="contentTitle">
              <h1>Results and resources</h1>
            </div>
            <WorkplaceResultsResourceItems startQuiz={props.startQuiz} />
          </div>
        </div>
      </div>
    </>
  )
}
export default WorkplaceResultsResources
